import Image from "next/image";
import React from "react";
import { parseHtml } from "@/utils/common";

interface Props {
  offices?: any;
  label: string;
  CIN: string;
  GSTIN: string;
  image?: string;
}

const baseUrl = process.env.NEXT_PUBLIC_REACT_APP_RESOURCE_BASE_URL ?? "";

const FooterLocation: React.FC<Props> = ({ offices = [],
  label,
  CIN,
  GSTIN,
  image,
}) => {
  // Group offices by country
  const groupedOffices = React.useMemo(() => {
    const grouped: { [key: string]: any[] } = {};

    offices.forEach((office: any) => {
      const country = office?.country || 'Unknown';
      if (!grouped[country]) {
        grouped[country] = [];
      }
      grouped[country].push(office);
    });

    // Flatten the grouped offices back into a single array
    return Object.values(grouped).flat();
  }, [offices]);

  return (
    <div>
      {/* Footer logo */}
      <div className="flex justify-center items-center -mb-[35px] xl:pb-[44px] md:pb-[92px] xl:-mb-[168px] md:-mb-[176px] sm:-mb-[56px] xs:-mb-[44px]">
        <Image
          src={image ? `${baseUrl}${image}` : "/images/Footer-logo.svg"}
          width={958}
          height={286}
          alt="logo"
          className="block object-cover object-center w-[280px] h-[83px] xl:w-[958px] xl:h-[286px] md:w-[656px] md:h-[196px] sm:w-[450px] xs:w-[355px] sm:h-[134px] xs:h-[105px]"
          quality={80}
        />
      </div>

      {/* Office grid */}
      <div className="md:py-8 py-6 md:px-6 px-4 border border-white/15 bg-black/20 backdrop-blur-[20px]">
        <div className="text-white grid lg:grid-cols-3 sm:grid-cols-2 col-span-1 md:gap-7 gap-6 justify-between">
          {(groupedOffices).map((office: any, index: number) => {
            // Check if current office has the same country as the previous one
            const shouldHideCountry = index > 0 && groupedOffices[index - 1]?.country === office?.country;

            return (
              <div key={office.id} className={`
              ${index === 1 && 'lg:col-span-1 sm:col-span-2'}
              `}>
                <p className={`${shouldHideCountry ? "sm:block hidden opacity-0" : "opacity-100"} mb-4 text-subtitle-3 font-bold uppercase py-2 pb-0.5 px-3 w-fit border border-white/15`}>{office?.country}</p>
                <div key={office.id}
                  className="">
                  <h5 className="text-subtitle-3 font-bold text-primary-text-white">
                    {office.office || ""}
                  </h5>
                  <span className="text-subtitle-3 font-regular text-primary-text-white mt-3 block">
                    {parseHtml(office.Address || "")}
                  </span>
                </div>
              </div>
            );
          })}
        </div>

        {/* Company info */}
        <div className="flex lg:flex-nowrap flex-wrap justify-between items-center gap-3 pt-7 mt-7 border-t border-white/15">
          <h5 className="text-subtitle-3 font-bold text-primary-text-white">
            {label || ""}
          </h5>
          <div className="flex justify-end sm:flex-row flex-col sm:items-center items-start gap-3">
            <p className="text-subtitle-3 font-regular text-primary-text-white">
              CIN: {CIN || ""}
            </p>
            <span className="text-primary-text-white sm:block hidden">|</span>
            <p className="text-subtitle-3 font-regular text-primary-text-white">
              GSTIN: {GSTIN || ""}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
export default FooterLocation;